import { displayTime } from '../../time';
import {
  getPersonName,
  getItemOrDefaultToValue,
  getCountryName,
} from 'utils/details';
import { SECURITY_COMPANY_APPROVAL_STATUS } from 'utils/constants/securityCompany';

export const transform = (pendingCompanies, countryList, timeZone) => {
  return pendingCompanies.map(pendingCompany => ({
    id: pendingCompany.id,
    name: pendingCompany.name,
    managerName: getPersonName(pendingCompany.manager),
    managerEmail: getItemOrDefaultToValue(pendingCompany.manager, 'email', '-'),
    country: pendingCompany.country
      ? getCountryName(pendingCompany.country, countryList)
      : '-',
    dateReceived: displayTime({
      timestamp: pendingCompany.dateReceived,
      timeZone,
    }),
    dateUpdated: pendingCompany.dateUpdated
      ? displayTime({
          timestamp: pendingCompany.dateUpdated,
          timeZone,
        })
      : '-',
    status: SECURITY_COMPANY_APPROVAL_STATUS[pendingCompany.status],
  }));
};
